export type SessionStorageKeys = 'state' | 'sessionOIDC';
export const EnabledSessionsStorageKeys: Record<SessionStorageKeys, SessionStorageKeys> = {
  state: 'state',
  sessionOIDC: 'sessionOIDC'
};
